import { Dispatch, FC, SetStateAction } from 'react';
import { PlanV3 } from 'types/modelsV3';

interface AssignEsimConfirmationProps {
    handleSubmit: () => void;
    setShowConfirmation: Dispatch<SetStateAction<boolean>>
    selectedPlan?: PlanV3;
    email?: string;
    stripeTransactionId?: string;
}

export const AssignEsimConfirmation: FC<AssignEsimConfirmationProps> = ({ handleSubmit, setShowConfirmation, selectedPlan, email, stripeTransactionId }) => {

    return <>
        <p className='mb-m'>
            Assign the plan {selectedPlan?.name && <span className='highlight-accent bold selectable-text'>{selectedPlan.name} / {selectedPlan.provider.name}</span>} for the user with email: <span className='highlight-accent bold selectable-text'>{email}</span>{stripeTransactionId && <>replacing the existing plan with payment ID: <span className='highlight-accent bold selectable-text'>{stripeTransactionId}</span></>}?
        </p>
        <div className='two-columns-expand-one'>
            <div />
            <div>
                <button onClick={() => setShowConfirmation(false)} id='esim-assign-confirmation-button' className='pd-s bold mr-s'>CANCEL</button>
                <button onClick={handleSubmit} id='esim-assign-confirmation-button' className='pd-s bold mr-m'>SUBMIT</button>
            </div>
        </div>
    </>
}
